import { AbacoWebModule, RouterReadyEvent, VueRouter, ApplicationReadyEvent, MenuItem } from '@abaco/web-common/src/app';
import globals from "./globals";
import HelperInfoApi from "./api/HelperInfoApi";
import UserVuexModule from "./state";
import TosModule from "@abaco/sso-web-module/src/tos-module/index";
import { HTTPClient, propsToDate } from '@abaco/web-common/src/HTTP';
import routes from "./routes";
export const MODULE_ID = "user_module";
import MenuModule from '@abaco/menu-module/src/modules/menu';
import SsoVuexModule from '@abaco/sso-web-module/src/abaco-module/state';
import { UserProfile } from './models/UserProfile';
import { dbGIStoStandardPage } from '@abaco/web-common/src/Paging';

export default class UserModule implements AbacoWebModule {
    public static MODULE_ID = MODULE_ID;

    private apiCreated = false;
    private hlpInfApi!: HelperInfoApi;

    private router!: VueRouter;
    // private http!: HTTPClient;
    private httpClient!: HTTPClient;
    private ssoStore!: SsoVuexModule;

    readonly id = MODULE_ID;
    readonly globalComponents = globals;
    readonly vuexModule = new UserVuexModule();

    public get http(): HTTPClient {
        return this.httpClient;
    }

    routes = routes

    dependsOn = {
        [TosModule.MODULE_ID]: () => new TosModule(),
        [MenuModule.MODULE_ID]: () => new MenuModule()
    }

    onApplicationReady(evt: ApplicationReadyEvent) {
        this.httpClient = evt.http;
    }

    onRouterReady(evt: RouterReadyEvent) {
        this.router = evt.router;
        // this.http = evt.http;
    }

    async beforeEnterAnyRoutes(http: HTTPClient) {
        if (this.apiCreated) {
            return;
        }
        this.apiCreated = true;

        const HelperInfoApi = (await import("./api/HelperInfoApi")).default;
        this.hlpInfApi = new HelperInfoApi(http);
    }

    get helperInfoApi() {
        return this.hlpInfApi;
    }

    public async getMessageCount(): Promise<number> {
        const url = `/sitiagri-rest-api/api_basic/v1/messages/conversations`;
        const params = {
            count: 0,
            filter: `num_messages_to_read gt 0`
        }
        const res = await this.http.get(url, { params });

        return res.data.totalcount;
    }

    public async getUserContracts(userId: string): Promise<number> {
        const url = `/sitiagri-rest-api/api_basic/v1/bc_business/contracts/getAllContractsForAdminUser/${userId}`;
        const params = {
            offset: 0,
            count: 0,
        }
        const res = await this.http.get(url, { params });
        return res.data.contract.length;
    }

    public async getUserProfile(userId: string): Promise<UserProfile> {
        const res = await this.http.get("/siticatasto/dbgis-servlet/rest_tl_data", {
            params: {
                svccode: "gurl_services/get_gu_accreditamento",
                userid: userId
            }
        });

        const ret = dbGIStoStandardPage<UserProfile>(res.data, 25).records[0];
        propsToDate(ret, ["born_date"]);
        return ret;
    }

    public async updateUserProfile(userProfile: UserProfile, userId: string) {
        await this.http.get("/siticatasto/dbgis-servlet/rest_tl_data", {
            params: {
                svccode: "gurl_services/update_gu_accreditamento",
                username: userId,
                email: userProfile.email,
                userid: userProfile.userid,
                subject_identifier: userProfile.subject_identifier,
                name: userProfile.name,
                surname: userProfile.surname,
                sex: userProfile.sex,
                born_date: userProfile.born_date,
                born_city: userProfile.born_city,
                residence_city: userProfile.residence_city,
                post_code: userProfile.post_code,
                address: userProfile.address,
                phone: userProfile.phone,
                request_id: userProfile.request_id,
                denomination: userProfile.denomination
            }
        });
    }

    public async canViewAppSwitcher() {
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/user_registry/module_competencies/PORTAL_VERTS/A4GRAPES`)
        return res.data.result
    }

}
